// Fix for accessibility issues. Issue # VII26-08
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Package2, PanelLeft } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from "../../component/ui/tooltip";
import { Button } from "../../component/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../component/ui/dropdown-menu";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator, useBreadCrumb } from "../../component/ui/breadcrumb";
import { dashboardIcon, dashboardIconBlue, reportIcon, reportIconBlue } from "../../assets/icons";
import { DataTable } from "../../component/table/dataTable";
import { Dashboard } from "./Dashboard";
import { MdOutlineDelete } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { nullUserDetails } from "../../context/actions/userAction";
import { loaderSet } from "../../context/actions/loaderAction";
import AdvancedDropdown from "../../component/ui/multi-selection-dropdown-menu-with-search";
import { getAllInvestorSchemeReport } from "../../utils/util";
import Profile from "../../component/profile";
import { FaRegEye } from "react-icons/fa";
export function Layout() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [collapsed, setCollapsed] = useState(true); // Sidebar state
  // const [selectedTab, setSelectedTab] = useState("Dashboard"); // Track the selected tab

  const { selectedTab, setSelectedTab, selectedSubTab, setSelectedSubTab } = useBreadCrumb()
  const location = useLocation()
  const [schemeAndClassOption, setSchemeAndClassOption] = useState(["Option 1", "Option 2", "Option 3"])
  const [selectedSchemeOptions, setSelectedSchemeOptions] = useState([])
  const [investorSchemeReport, setInvestorSchemeReport] = useState([])
  const [tickerMessage, setTickerMessage] = useState()
  const investorInfo = useSelector(state => state.investorInfo)
  const allSchemeDetails = useSelector(state => state.schemeInfoAgainstInvestor);
  const userInfo = useSelector(state => state.user)
  const columns = [
    { id: 'report_name', header: 'Report Name' },
    // { id: 'report_type', header: 'Report Type' },
    { id: 'created_at', header: 'Uploaded Date' },
    // { id: 'scheme', header: 'Scheme' },
    // { id: 'class', header: 'Class' },
  ];

  useEffect(() => {
    if (investorInfo && Array.isArray(investorInfo.schemes)) {
      const schemeAndClass = investorInfo.schemes.map(
        (item, index) => (`${item.scheme_name}-${item.scheme_class}`)
      );
      setSchemeAndClassOption(schemeAndClass)
    } else {
      setSchemeAndClassOption([]);
    }
  }, [investorInfo])



  useEffect(() => {
    if (schemeAndClassOption?.length > 0) {
      setSelectedSchemeOptions(schemeAndClassOption);
      console.log("setSelectedSchemeOptions updated with", schemeAndClassOption);
    }
  }, [schemeAndClassOption]); // Depend on the scheme state


  const handleGetAllInvestorSchemeReport = async () => {
    const payload = {
      user_id: investorInfo && investorInfo?.user_id,
      report_type: "yearly",
      scheme_name: selectedSchemeOptions && selectedSchemeOptions.length > 0 && selectedSchemeOptions[0]?.split("-")[0],
      scheme_class: selectedSchemeOptions && selectedSchemeOptions.length > 0 && selectedSchemeOptions[0]?.split("-")[1],
      page_no: 1,
      per_page: 10
    }
    try {
      const response = await getAllInvestorSchemeReport(payload)
      console.log("handleGetAllInvestorSchemeReport", response)
    } catch (error) {
      console.log("Error in handleGetAllInvestorSchemeReport ", error)
    }
  }

  useEffect(() => {
    handleGetAllInvestorSchemeReport()
  }, [selectedSchemeOptions, investorInfo])

  const handleToggle = () => {
    setCollapsed(!collapsed); // Toggle collapsed state
  };

  const handleTabClick = (tabName) => {
    setSelectedTab(tabName); // Set the selected tab on click
  };

  // useEffect(()=>{
  //  console.log("Seleceted scheme options",schemeAndClassOption)
  // },[selectedSchemeOptions,allSchemeDetails])

  useEffect(() => {
    setSelectedTab("Dashboard")
    if (selectedTab === "Dashboard") {
      setSelectedSubTab("Overview")
    }
    if (selectedTab === "Reports") {
      setSelectedSubTab("week")
    }
  }, [])

  const navigation = [
    { name: "Dashboard", href: "#", icon: dashboardIcon, icon2: dashboardIconBlue, current: selectedTab === "Dashboard" },
    { name: "Reports", href: "#", icon: reportIcon, icon2: reportIconBlue, current: selectedTab === "Reports" },
  ];


  const handleInvestorReportView = async (reportUrl) => {
    try {
      // Check if the report URL is valid before opening
      if (reportUrl) {
        // Open the report URL in a new tab
        window.open(reportUrl, "_blank");
      } else {
        console.log("Invalid report URL");
      }
      console.log("REPORT URL", reportUrl)
    } catch (error) {
      console.log("Error in handleSchemeReportView function", error);
    }
  };

  const buttonOptions = [


    {
      icon: <FaRegEye />,
      alt: "",
      text: <span className="text-base font-semibold">View</span>,
      iconHeight: 17,
      iconWidth: 17,
      iconColor: "black",
      name: "View",
      actionHandleInvestorReportView: handleInvestorReportView
    },
    // {
    //   icon: <IoMdDownload />,
    //   alt: "",
    //   text: <span className="text-base font-semibold">Download</span>,
    //   iconHeight: 17,
    //   iconWidth: 17,
    //   iconColor: "black",
    //   name: "Download",
    //   actionHandleDownloadSchemeReport: handleDownloadSchemeReport
    // },
  ];

  const handleLogout = () => {
    dispatch(loaderSet(true))
    dispatch(nullUserDetails())
    navigate("/")
    setTimeout(() => {
      dispatch(loaderSet(false))
    }, 3000);

  }

  const handleNavigateToProfile = () => {
    dispatch(loaderSet(true))
    navigate("/investor/profile")
    setTimeout(() => {
      // dispatch(nullUserDetails())
      dispatch(loaderSet(false))
    }, 3000);

  }

  const handleSetTickerMessage = (message) => {
    setTickerMessage(message)
  }


  useEffect(() => {
    if (
      allSchemeDetails &&
      allSchemeDetails.length > 0 &&
      selectedSchemeOptions &&
      selectedSchemeOptions.length > 0
    ) {
      const tickerMessage =
        allSchemeDetails
          .filter(
            (scheme) =>
              scheme.scheme_class === selectedSchemeOptions[0]?.split("-")[1] &&
              scheme.scheme_name === selectedSchemeOptions[0]?.split("-")[0] &&
              scheme.ticker_status === true
          )
          .map((scheme) => scheme.ticker_message)
          .find((message) => message !== null) || false; // Returns the message or false if none found

      // Trigger handleSetTickerMessage only if tickerMessage is found
      console.log("TICKER MESSAGE:", tickerMessage);
      handleSetTickerMessage(tickerMessage);
    }
  }, [selectedSchemeOptions, allSchemeDetails]); // Depend on selectedSchemeOptions and allSchemeDetails



  return (
    <TooltipProvider>
      <div className="flex min-h-screen w-full flex-col bg-muted/40">
        <aside className={`fixed inset-y-0 left-0 z-10 flex flex-col transition-all duration-300 ease-in-out ${collapsed ? "w-14" : "w-60"} bg-background`}>
          <nav className="flex flex-col items-center gap-4 px-2 py-5">
            {/* <Link
              href="#"
              className="group flex h-9 w-9 shrink-0 items-center justify-center gap-2 rounded-full bg-[#0D215C] text-lg font-semibold text-primary-foreground"
            >
              <Package2 className="h-4 w-4 transition-all group-hover:scale-110" />
              <span className="sr-only">Acme Inc</span>
            </Link> */}
            {/* accessiblity fix for silktide issues - semantic navigation list */}
            <ul className="flex flex-col items-center gap-4 w-full">
              {navigation.map((item, index) => (
                <li key={index} className="w-full list-none">
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <button
                        type="button"
                        onClick={() => handleTabClick(item.name)}
                        aria-label={`${item.name} navigation item`}
                        aria-current={item.current ? "page" : undefined}
                        className={`flex items-center gap-4 px-2.5 h-9 w-full rounded-lg transition-colors hover:text-foreground focus-visible:ring-2 focus-visible:ring-[#0D215C] focus-visible:ring-offset-2 ${item.current ? "bg-accent text-[#0D215C]" : "text-black"
                          }`}
                      >
                        <span className={`flex items-center ${collapsed ? "w-full justify-center" : "w-auto justify-start"}`}>
                          <img
                            src={item.current ? item.icon2 : item.icon}
                            alt=""
                            aria-hidden="true"
                            className={` w-5 font-bold `}
                          />
                        </span>
                        {!collapsed && <span className="ml-2">{item.name}</span>}
                      </button>
                    </TooltipTrigger>
                    {collapsed && <TooltipContent side="right">{item.name}</TooltipContent>}
                  </Tooltip>
                </li>
              ))}
            </ul>
          </nav>
          <button
            type="button"
            className="mt-auto mb-4 p-5 text-black w-full focus-visible:ring-2 focus-visible:ring-[#0D215C] focus-visible:ring-offset-2"
            onClick={handleToggle}
            aria-expanded={!collapsed}
            aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            <PanelLeft className="h-5 w-5" />
          </button>
        </aside>

        <div className={`flex-1 flex flex-col transition-all duration-300 ease-in-out ${collapsed ? "ml-14" : "ml-60"}`}>
          {tickerMessage && (
            <div
              role="status"
              aria-live="polite"
              className="w-full bg-[#0D215C] text-white p-5 text-2xl font-bold"
            >
              <p className="truncate">{tickerMessage.replace(/<[^>]+>/g, "")}</p>
            </div>
          )}

          <header className="sticky w-full justify-between items-center top-0 z-30 flex h-14 gap-4 border-b bg-background px-4">
            <Breadcrumb className="hidden md:flex pl-5 ">
              <BreadcrumbList>
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link to="/investor">Investor</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />

                <>
                  <BreadcrumbItem>{location.pathname === "/investor/profile" ? "Profile" : selectedTab}</BreadcrumbItem>
                </>

              </BreadcrumbList>
            </Breadcrumb>

            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button
                  type="button"
                  variant="outline"
                  size="icon"
                  aria-label="Open user menu"
                  className="overflow-hidden rounded-full flex items-center"
                >
                  <img
                    src={userInfo && userInfo.image_url ? userInfo.image_url : "./avatar.png"}
                    width={36}
                    height={36}
                    alt="User avatar"
                    className="overflow-hidden rounded-full"
                  />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem>
                  <button type="button" onClick={() => handleNavigateToProfile()}>
                    Profile
                  </button>
                </DropdownMenuItem>
                <DropdownMenuItem>
                  <button type="button" onClick={() => handleLogout()}>
                    Logout
                  </button>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </header>

          <main className="flex-1 h-screen overflow-y-auto p-4">
            {/* accessiblity fix for silktide issues - H1 heading */}
            <h1 className="sr-only">{location.pathname === "/investor/profile" ? "Profile" : selectedTab}</h1>
            {/* Conditionally render components based on selected tab */}
            {location.pathname === "/investor/profile" ? <Profile /> :
              <>
                {selectedTab === "Dashboard" && <Dashboard handleSetTickerMessage={handleSetTickerMessage} />}
                {selectedTab === "Reports" &&
                  <>
                    <div className="flex w-full justify-end  items-center  ">

                      {/* Ticker name Input field */}
                      {/* Dropdown Menu */}
                      <div className="w-64 h-10 mr-5">
                        <AdvancedDropdown
                          name="Scheme"
                          id="scheme"
                          options={schemeAndClassOption}
                          selectedOptions={selectedSchemeOptions}
                          setSelectedOptions={setSelectedSchemeOptions}
                          placeholder="Scheme"
                          select={"single"}
                          label={false}
                        />
                      </div>





                    </div>
                    <DataTable columns={columns} tableFor="InvestorSchemeReport" selectedSchemeOptions={selectedSchemeOptions} buttonOptions={buttonOptions} />
                  </>
                }
              </>

            }
          </main>
        </div>
      </div>
    </TooltipProvider>
  );
}
